import {createContext} from '@lit/context';
import {CollectionsState, ProductsState} from './wishlist-state.js';

export const productsContext = createContext<ProductsState>('productsContext');
export const collectionsContext = createContext<CollectionsState>('collectionsContext');
